import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvatarModule } from '@y42/core/avatar';
import { QuillModule } from 'ngx-quill';
import { ChatAvatarComponent } from './chat-avatar.component';

@NgModule({
  declarations: [ChatAvatarComponent],
  imports: [CommonModule, MatTooltipModule, AvatarModule, QuillModule],
  exports: [ChatAvatarComponent],
})
export class ChatAvatarModule {}
